import '../scss/components/facet-list.scss';
import {getUrl} from "./utils/router.js";
import { formatUrl } from './utils/urlFormatter.js';

const facetLists = document.querySelectorAll('.facet-list');
let facetListsLoading = true;

if (facetLists.length) {
    facetLists.forEach(async (facetList) => {
        const dataName = facetList.dataset.name;
        const itemsList = facetList.querySelector('.facet-list_items');
        const loadingSpinner = document.createElement('div');
        loadingSpinner.classList.add('aps-loading');
        loadingSpinner.innerHTML = `
            <svg viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20"></circle>
            </svg>
        `;
        facetList.appendChild(loadingSpinner);

        try {
            const payload = await fetch(`/api/aps/facet/${dataName}/entries`);
            const data = await payload.json();

            if (payload.status === 200) {
                facetListsLoading = false;
                loadingSpinner.remove();

                const entries = data.documents.facets.facet.descriptor;

                entries.forEach(entry => {
                    const url = {
                        pathname: getUrl('search'),
                        query: {
                            q: '*',
                            ...(entry.value !== null ? {requiredfields: `"${dataName}:${entry.value}"`} : {}),
                        },
                    };
                    const item = document.createElement('li');
                    item.classList.add('facet-list_item');
                    item.innerHTML = `
                        <a class="facet-list_link" href="${formatUrl(url)}" title="Suchen nach '${entry.value}'">
                            <p class="facet-list_entry">
                               ${entry.value} <span>(${entry.hits.toLocaleString('de-DE')})</span>
                            </p>
                        </a>
                    `;
                    itemsList.appendChild(item);
                });
            }
        } catch (error) {
            console.error(error);
            facetListsLoading = false;
            loadingSpinner.remove();

            const errorEl = document.createElement('section');
            errorEl.classList.add('loading-error');
            errorEl.innerHTML = `
                <div>
                    <p class="loading-error-title">Ein Fehler ist aufgetreten.</p>
                    <p class="loading-error-content">
                        <span >Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</span>
                        <a href="/" class="button" title="Zur Startseite wechseln">Zur Startseite wechseln</a>
                    </p>
                </div>
            `;
            facetList.appendChild(errorEl);
        }
    });
}